import React from "react";
import {
  Column,
  TableCellRenderer
} from "react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { TotalPrice } from "src/core/prices/components/TotalPrice";
import { IList } from "src/core/lists/api/lists.api";

export interface IListTableColumns {
  terminology: ITerminology;
  ActionButton?: TableCellRenderer;
}

export const adminListTableColumns = (params: IListTableColumns): Column[] => [
  globalTableColumns.id(),
  globalTableColumns.customer(params.terminology),
  globalTableColumns.branch(params.terminology),
  globalTableColumns.scheduleData(params.terminology),
  globalTableColumns.productCount(params.terminology),
  globalTableColumns.standardText({
    Header: "Total",
    accessor: "id",
    Cell: row => (
      <TotalPrice
        lines={row.original.listLines}
        id={row.original.id}
        totalOnly
        currency={(row.original as IList).branch.priceCode?.currency}
        discountValue={row.original.branch.discount}
      />
    ),
    width: 100,
    filterable: false
  }),
  globalTableColumns.scheduleStatus(params.terminology),
  globalTableColumns.date({
    header: "Created",
    accessor: "createdAt"
  }),
  globalTableColumns.date({
    header: "Last Updated",
    accessor: "updatedAt",
    show: false
  }),
  globalTableColumns.standardText({
    Header: "List Name",
    accessor: "name"
  }),
  globalTableColumns.actions({
    cell: params.ActionButton,
    width: 200
  })
];
